import { Segmented as AntdSegmented } from "@empglabs/backoffice-ui-kit"

const Segmented = props => {
  return <AntdSegmented {...props} />
}

export default Segmented
